import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarClasseLayer from "../components/CadastrarClasseLayer";
import { useTranslation } from "../i18n/I18nContext";
import { getClassesLabels } from "../utils/classesLabels";

const CadastrarClassePage = () => {
  const { t } = useTranslation();
  const labels = getClassesLabels();
  return (
    <MasterLayout>
      <Breadcrumb title={t("classe.breadcrumb.create", { term: t(labels.singular) })} />
      <CadastrarClasseLayer />
    </MasterLayout>
  );
};

export default CadastrarClassePage;
